import { ShieldCheck, BadgeCheck, Clock3, ThumbsUp } from 'lucide-react';
import './TrustBar.css';

const POINTS = [
  { icon: ShieldCheck, label: 'Assurance responsabilité civile' },
  { icon: BadgeCheck, label: 'Intervenants vérifiés & formés' },
  { icon: Clock3, label: 'Réponse sous 24h ouvrées' },
  { icon: ThumbsUp, label: 'Satisfait ou nous rééintervenons' },
];

/** Bandeau de réassurance, placé juste sous le hero pour rassurer avant la conversion. */
export function TrustBar() {
  return (
    <div className="trust-bar">
      <div className="container trust-bar__inner">
        {POINTS.map((p) => (
          <div className="trust-bar__item" key={p.label}>
            <p.icon size={18} />
            <span>{p.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
